/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { Company } from '../../models';
import img from '../../public/images/meit-purple.png';

interface AllyCardProps {
  ally: Company;
  categoryId: string;
}

function AllyCard({ ally, categoryId }: AllyCardProps) {
  return (
    <div className="bg-system-100 rounded-lg ease-in-out duration-300 flex flex-col overflow-hidden border pb-2 w-[208px] h-[192px] sm:w-[240px] sm:h-[224px] group">
      <Link href={`/category/${categoryId}?allyQueryParam=${ally._id}`}>
        <div className="relative overflow-clip group">
          {ally?.logo ? (
            // eslint-disable-next-line @next/next/no-img-element
            <img
              src={ally?.logo.src}
              alt="ally_logo"
              className="object-cover w-full h-[150px] sm:h-[180px] object-center cursor-pointer ease-in-out duration-150 scale-110 group-hover:scale-100"
            />
          ) : (
            <Image
              alt="Imagen de perfil"
              src={img}
              className="object-cover w-full h-[180px] object-center cursor-pointer ease-in-out duration-150 scale-110 group-hover:scale-100"
            />
          )}
        </div>
        <section className="h-full w-full p-2 border-t">
          <h3 className="w-full text-neutral-cold-800 font-bold text-base ">
            {ally?.name}
          </h3>
        </section>
      </Link>
    </div>
  );
}

export default AllyCard;
